
(function() {

    // This function shows or hides the certification labels based on the selected variant
    function updateCertificationLabels() {

        // use a timeout to wait for the url to update before we check it
        setTimeout(function() {
            // read variant ID from URL
            var urlParams = new URLSearchParams(window.location.search);
            var variantId = urlParams.get('variant');
            if (variantId) {
                // for all certification labels, hide them unless they have the variant ID in their class
                document.querySelectorAll('.variant-certification-label').forEach(function(element) {
                    if (element.classList.contains('variant-' + variantId)) {
                        element.classList.remove('certification-hidden');
                    } else {
                        element.classList.add('certification-hidden');
                    }
                });
            } else {
                // this happens on initial page load or when a product has no variants. The liquid code will add the correct classes in that case
            }
        }, 100);
    }

    // Run it once on page load:
    updateCertificationLabels();

    // Watch for variant change events by listening for clicks on the variant buttons
    document.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('variant__button')) {
            console.log("Button clicked"); // Debugging: Check if button click event is captured
            updateCertificationLabels();
        }
    });

    // Function to show the certification popup on hover
    function registerCertificationPopup() {
        var divs = document.querySelectorAll('.certification-label');
        divs.forEach(function(div) {
            div.addEventListener('mouseover', function() {
                this.classList.add('hovered_div');
            });
            div.addEventListener('mouseout', function() {
                this.classList.remove('hovered_div');
            });
        });
    }

    // Call the function when the DOM is ready
    registerCertificationPopup();
})();